import React, { CSSProperties } from 'react'
import { Icon } from '../../../components/Icon'

interface LargeButtonProps {
  title: string
  onClick?: () => void
  ButtonItemStyleContainer?: CSSProperties
  ButtonStyle?: CSSProperties
  ButtontitleStyle?: string
  icon?: string
  iconStroke?: string
  iconStrokeWidth?: number
  iconSize?: number
  rightIcon?: string
  bagdeLabel?: string
  badgeColor?: string
  downloadPolicy?: () => void
}

const PoliciesLargeButton: React.FC<LargeButtonProps> = ({
  title,
  onClick,
  ButtonItemStyleContainer,
  ButtonStyle,
  ButtontitleStyle,
  icon,
  iconStroke,
  iconStrokeWidth,
  iconSize,
  rightIcon,
  bagdeLabel,
  badgeColor,
  downloadPolicy
}) => {
  return (
    <div onClick={onClick} className="w-full flex flex-col gap-[20px] mx-auto">
      <div
        style={ButtonItemStyleContainer}
        className="w-[100%] rounded-[16px] border"
      >
        <button
          style={ButtonStyle}
          className={`w-full rounded-[16px] h-[48px] bg-text8 flex justify-between items-center py-4 px-4 text-left focus:outline-none`}
        >
          <div className="flex items-center w-full gap-2">
            <div className="flex-1 flex gap-2 items-center">
              {icon && (
                <Icon
                  name={icon}
                  strokeWidth={iconStrokeWidth ? iconStrokeWidth : 1}
                  stroke={iconStroke ? iconStroke : '#02698C'}
                  width={iconSize ? iconSize : 16}
                  height={iconSize ? iconSize : 16}
                />
              )}
              <p
                className={`${ButtontitleStyle ? ButtontitleStyle : 'text-sm leading-6 font-semibold text-text2'}`}
              >
                {title}
              </p>
              {rightIcon && (
                <span onClick={downloadPolicy}>
                  <Icon
                  name={rightIcon}
                  stroke={'#02698C'}
                  strokeWidth={1}
                  width={16}
                  height={16}
                />
                </span>
                
              )}
            </div>
            {bagdeLabel && (
              <div
                className={`${badgeColor} rounded-[40px] px-3 py-[6px] mr-1`}
              >
                <p className="text-xs font-medium leading-5 text-text2">
                  {bagdeLabel}
                </p>
              </div>
            )}

            <Icon
              name={'IconChevronRight'}
              stroke={'#02698C'}
              width={10}
              height={10}
              strokeWidth={1}
            />
          </div>
        </button>
      </div>
    </div>
  )
}

export default PoliciesLargeButton
